import { Navigate } from "react-router-dom";
import { getStorage } from "../utils/storage";

export const PublicRoutes = ({ children, restrictedAfterLogin }) => {
  const loggedIn = getStorage('user_session')
  if (loggedIn !== null && restrictedAfterLogin) {
    return <Navigate to={"/home"} />;
  }
  return children;
};
